@import '../../theme/mixins';
@import '../../theme/colors';

.table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
  .tableHead {
    position: relative;
    height: 27px;
  }
  th,
  td {
    padding-top: 0;
    padding-right: 20px;
    padding-bottom: 11px;
    &:first-child {
      padding-left: 38px;
    }
  }
  th {
    // fixes firefox header appearing behind td text
    z-index: 100;
    @include label1;
    text-transform: uppercase;
    position: sticky;
    top: 0;
    background: white;
    white-space: nowrap;
    .headerCellInner {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // match header inner heights for text positioning regardless of whether column is sortable
      height: 22px;
      > button {
        @include label1;
        text-transform: uppercase;
        background: white;
        white-space: nowrap;
        border: none;
        padding: 0;
        cursor: pointer;
      }
    }
    .sortGroup {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 4px;
    }
    // border without gaps that moves with position: sticky
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 1px;
      background-color: $lightGrey;
    }
  }
  td {
    @include caption;
    padding-top: 25px;
  }
}
